var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    width: 42.1875,
    height: 45,
    rx: 7.03125,
    fill: "#15DD98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.75 20.514V34.6248H27.7703V26.1485H20.1718V20.514H33.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.0572 14.3524L25.9726 19.1435H25.8855C25.6742 18.771 25.4181 18.4313 25.1247 18.122C24.0332 16.974 22.5463 16.4001 20.6592 16.4001C18.772 16.4001 17.2603 16.974 16.1787 18.122C15.1021 19.27 14.56 20.835 14.56 22.8217C14.56 24.8084 15.1021 26.3406 16.1787 27.4886C16.3279 27.6456 16.4845 27.7932 16.6486 27.9291C17.6755 28.7795 19.0057 29.2035 20.6442 29.2082V29.4214L15.122 34.6248C14.6744 34.4468 14.2368 34.2429 13.8091 34.0157C11.7256 32.9169 10.0746 31.3917 8.85875 29.4402C7.64042 27.4886 7.03125 25.284 7.03125 22.8217C7.03125 20.3594 7.64042 18.1572 8.85875 16.2056C10.0746 14.254 11.7256 12.7359 13.8091 11.6465C15.8927 10.5594 18.1752 10.0159 20.6592 10.0159C23.1431 10.0159 25.4629 10.5594 27.534 11.6465C28.8941 12.3634 30.0701 13.2654 31.0572 14.3524Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.707c931b469858ea3c0494503ba9d56f.svg";
export { ForwardRef as ReactComponent };